// 通过 Vue Router 写入的 history.state.position + popstate 事件推断本次导航的触发类型。
// Vue Router 4 在每次 push/replace/back/forward 时会在 history state 中维护一个单调递增的 position：
//   - push    ：新位置 = 旧位置 + 1，且不会触发 popstate（router.push / 链接点击 / 编程式跳转）
//   - replace ：位置不变，且不会触发 popstate（router.replace）
//   - back    ：位置变小，触发 popstate（浏览器/系统返回、手势返回、history.back）
//   - forward ：位置变大，触发 popstate（浏览器前进、history.forward）
//   - initial ：首次进入（lastPosition 尚未初始化）
//   - unknown ：拿不到 position（如非浏览器环境 / state 结构异常）
//
// 仅看 position 无法区分「push +1」和「forward 一步（也 +1）」，
// 所以额外监听 window 的 popstate：只有 back/forward 才会触发 popstate，
// push/replace 不会。结合两者即可准确判定。
//
// 由 router.afterEach 调用 recordNavigationTrigger() 统一维护，
// 页面 view 事件的 hook 通过 getNavigationTrigger() 读取，回填到埋点参数。

let lastPosition = null;
let currentTrigger = 'initial';
let popstateFired = false;

function onPopState() {
  popstateFired = true;
}

if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('popstate', onPopState);
}

export function recordNavigationTrigger() {
  if (typeof window === 'undefined' || !window.history || !window.history.state) {
    popstateFired = false;
    currentTrigger = 'unknown';
    return currentTrigger;
  }

  const pos = window.history.state.position;
  if (typeof pos !== 'number') {
    popstateFired = false;
    currentTrigger = 'unknown';
    return currentTrigger;
  }

  if (lastPosition === null) {
    currentTrigger = 'initial';
  } else if (popstateFired) {
    // popstate 只可能来自 back 或 forward
    currentTrigger = pos < lastPosition ? 'back' : 'forward';
  } else if (pos === lastPosition) {
    currentTrigger = 'replace';
  } else if (pos > lastPosition) {
    currentTrigger = 'push';
  } else {
    // 安全兜底：理论上 popstate=true 已处理 back，这里保留旧逻辑
    currentTrigger = 'back';
  }

  popstateFired = false;
  lastPosition = pos;
  return currentTrigger;
}

export function getNavigationTrigger() {
  return currentTrigger;
}

export function resetNavigationTrigger() {
  lastPosition = null;
  currentTrigger = 'initial';
  popstateFired = false;
}
